import { apiService, CreateFacilityAssessmentRequest, CreateFacilityAssessmentResponse } from '../../..'
import {
  GetCreditFacilityResponse,
  GetCreditFacilitySummaryResponse,
  PreAssesmentRequest,
  PreAssessmentResponse,
  CreateFacilityRequest,
  GetCloseCreditFacilityEligibilityResponse,
  ClosePayMonthlyRequest,
  FacilityIncomeAssessmentRequest,
  FacilityExpensesAssessmentRequest,
} from '../types'

const baseURL = '/portal/consumers'

export const creditFacilityService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getCreditFacility: build.query<GetCreditFacilityResponse, void>({
      query: () => {
        return {
          url: `${baseURL}/account/facility`,
          method: 'GET',
        }
      },
      providesTags: ['CreditFacility'],
    }),
    getCreditFacilitySummary: build.query<GetCreditFacilitySummaryResponse, void>({
      query: () => {
        return {
          url: `${baseURL}/account/facility/summary`,
          method: 'GET',
        }
      },
      providesTags: ['CreditFacilitySummary'],
    }),
    preAssessment: build.mutation<PreAssessmentResponse, PreAssesmentRequest>({
      query: ({ token }) => {
        return {
          url: `${baseURL}/checkout/${token}/facility/pre-assessment`,
          method: 'POST',
        }
      },
    }),
    createFacility: build.mutation<void, CreateFacilityRequest>({
      query: ({ token }) => {
        return {
          url: `${baseURL}/checkout/${token}/facility`,
          method: 'POST',
        }
      },
    }),
    validateFacilityIncome: build.mutation<void, FacilityIncomeAssessmentRequest>({
      query: ({ token, ...params }) => {
        return {
          url: `${baseURL}/checkout/${token}/facility/assessment/income`,
          method: 'POST',
          data: params,
        }
      },
      invalidatesTags: ['BankingSessions'],
    }),
    validateFacilityExpenses: build.mutation<void, FacilityExpensesAssessmentRequest>({
      query: ({ token, ...params }) => {
        return {
          url: `${baseURL}/checkout/${token}/facility/assessment/expenses`,
          method: 'POST',
          data: params,
        }
      },
      invalidatesTags: ['BankingSessions'],
    }),
    createFacilityAssessment: build.mutation<CreateFacilityAssessmentResponse, CreateFacilityAssessmentRequest>({
      query: ({ token, ...params }) => {
        return {
          url: `${baseURL}/checkout/${token}/facility/assessment`,
          method: 'POST',
          data: params,
        }
      },
      invalidatesTags: ['BankingSessions'],
    }),
    getCloseCreditFacilityEligibility: build.query<GetCloseCreditFacilityEligibilityResponse, void>({
      query: () => {
        return {
          url: `${baseURL}/account/facility/close-eligibility`,
          method: 'GET',
        }
      },
      providesTags: ['CreditFacilityClose'],
    }),
    closePayMonthlyCreditFacility: build.mutation<void, ClosePayMonthlyRequest>({
      query: (req) => {
        return {
          url: `${baseURL}/account/facility/close`,
          method: 'POST',
          data: req,
        }
      },
      invalidatesTags: ['CreditFacilityClose', 'CreditLimit', 'CreditFacility', 'CreditFacilitySummary'],
    }),
  }),
})
